import React, { useState } from "react"
import useSWR from "swr"
import Fade from "@material-ui/core/Fade"
/** Service */
import service from "services/Settings/AccountManagement/Resident"
/** Components */
import Loader from "components/Loader"
import Table from "components/Table"
import tableHeaders from "./table/tableHeaders"

const TableSettingAdmin: React.FC = () => {
  /** Methods */
  const fetchSettingsOwnersTenants = async () => service.getResidents()
  const [currentPage, setCurrentPage] = useState(0)

  const { data, isValidating } = useSWR(
    "fetchSettingsOwnersTenants",
    fetchSettingsOwnersTenants,
    {
      revalidateOnFocus: true
    }
  )
  const tableData = data?.data?._data

  if (isValidating) {
    return <Loader dark />
  }

  return (
    <Fade in={!isValidating} timeout={1000}>
      <div>
        <Table
          data={tableData || []}
          columns={tableHeaders()}
          minRows={2}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </Fade>
  )
}

export default TableSettingAdmin
